<template>
  <el-main :style="{height:height+'px'}" v-loading="loading">
    <div class="Scroll_content">
      
      <div class="daojishi" v-if="yicang" ref="elemnt">
					<!-- <div class="headerone" >
						<span>{{$t('Congratulation!')}}</span>
						<span> {{$t('You have a Special Offer!')}} </span>
					</div> -->
					<div class="headtwo">
						<!-- <span> {{$t('You have') }} </span> -->
						<div class="headtwo-time">
							<span class="timeclass"> {{time.value1}} </span>
							<span class="timeclass"> {{time.value2}}</span>
							<span>:</span>
							<span class="timeclass"> {{time.value3}}</span>
							<span class="timeclass"> {{time.value4}}</span>
							<span>:</span>
							<span class="timeclass"> {{time.value5}}</span>
							<span class="timeclass"> {{time.value6}}</span>
						</div>
						<div class="headtwo-timetext">
							<span class="one">{{$t('Hours')}}</span>
							<span  class="two" style="margin-left: 32px">{{$t('Minutes')}}</span>
							<span  class="three" style="margin-left: 33px">{{$t('Seconds')}}</span>
						</div>
						<!-- <div class="timeleft">Left!</div> -->
					</div>
					<div class="headthree" v-if="plan_info">
						<div class="headthree-img">
							<div class="imgone"> <img src="../../assets/timer 1.png" alt=""></div>
						    <div class="imgtwo"> <img src="../../assets/Group 112.png" alt=""></div>
							<span>TODAY ONLY</span>
						</div>
						<div class="headthree-taocan" >
							<div class="sin">
						        <div class="base_content base_sin" :style="'background:'+plandata.color" v-if="plandata.is_icon_show == true"> <img src="../../assets/heart.png" alt=""> {{plandata.tags}}</div>
						    </div>
							<span class="spanone" > {{plandata.title}} </span>
							<span class="spantwo">{{ plandata.remarks }}</span>
							<div class="p-1 spantwo-div"   v-if="plandata.describe">
								<span class="spantwo-span">{{ plandata.describe }}</span>
							</div>
							<span class="spanthree" > <span >{{ plandata.price }}</span> /month</span>
							<span class="spanfour">{{ plandata.discount }}</span>
							<div>
								<el-button  class="buttoninit" type="primary" size="default" @click="local_play(plandata)">{{$t('Continue')}} </el-button>	
							</div>
						</div>	
				  </div>

					<div class="headthree" v-if="good_info">
						<div class="headthree-img">
							<div class="imgone"> <img src="../../assets/timer 1.png" alt=""></div>
						    <div class="imgtwo"> <img src="../../assets/Group 112.png" alt=""></div>
							<span>TODAY ONLY</span>
						</div>
						<div class="headthree-taocan" >
							<span class="spanone"> {{ gooddata.quantity }}</span>
							<span class="spantwo">{{ gooddata.describe }}</span>
							<span class="spanthree"> <span>{{ gooddata.price }}</span> </span>
							<div>
								<el-button  class="buttoninit" type="primary" size="default" @click="hour_play(gooddata)">{{$t('Continue')}} </el-button>	
							</div>
						</div>	
				  </div>

					<!-- <transition name="slide-fade">
					   <div class="interbox" v-if="btnFlag"  @click="toTop"> {{$t('Continue')}} </div>
					</transition> -->
		     </div>


      <div>
 <!-- v-if="us_info.member_status != 1" -->
        <div v-if="us_info.member_status != 1">     
          <div class="simkeropl">{{$t('new_test5.Pick_a_Plan')}}</div>
          <div class="select_ry">
              <span>{{$t('new_test5.Number_of_Kids')}}&nbsp;&nbsp;&nbsp;</span>
              <span class="sz" :class="{checked:index==n}" v-for="(item,index) in children_list" :key="index" @click="index_clind(index,item)">
                <img v-if="index == 0 && n == 0" src="../../assets/l1.svg" alt="">
                <img v-if="index == 0 && n != 0" src="../../assets/h1.svg" alt="">
                <img v-if="index == 1 && n == 1" src="../../assets/l2.svg" alt="">
                <img v-if="index == 1 && n != 1" src="../../assets/h2.svg" alt="">
                <img v-if="index == 2 && n == 2" src="../../assets/l3.svg" alt="">
                <img v-if="index == 2 && n != 2" src="../../assets/h3.svg" alt="">
                {{item.kids}}
              </span>
          </div>
          <div class="flex-wrap-start">
              <div class="top_month-div" v-for="(item,index) in package_list" :key="index">
                  <div class="grid-content bg-purple hrp">
                    <div class="sin">
                      <div class="base_content" :style="'background:'+item.color" v-if="item.is_icon_show == true"> <img src="../../assets/Heart.svg" alt=""> {{item.tags}}</div>
                    </div>
                      <div class="imtxt">{{item.title}}</div>
                      <div class="wenzis">{{item.remarks}}</div>

                      <div class="m_tin">
                        <div class="kunmder" v-if="item.describe">{{item.describe}}</div>
                      </div>
                      

                      <div class="ikk_jiage">
                          <span class="num">{{item.price}}<span class="immmqqq">/{{$t('pay_Success.month')}}</span></span>
                      </div>
                      <!-- <div class="miaoshu">${{item.discount}}</div> -->
                      <div class="botton_content">
                          <div class="sihh_list" v-for="(items,index) in item.plan_details" :key="index">
                            <img src="../../assets/shape1oo.svg" alt="">
                              <span class="sin_imm">{{items}}</span>
                          </div>    
                          
                      </div>
                      <div class="send" @click="local_play(item)">{{$t('new_test5.Continue')}}</div>
                  </div>
              </div>
          </div>
        </div>

        <div> 
          <div class="simkeropl mhn">{{$t('new_test5.Pay_as_You_Go')}}</div>

          <div :class="getCreatPlanList.length==1?'flex-wrap':'flex-center'">
            <div class="wrap-div" v-for="(item,index) in getCreatPlanList" :key="index">
                <div class="grid-content bg-purple">
                    <div class="tossu">{{item.quantity}}</div>
                    <div class="xiamm">{{item.describe}}</div>
                    <div class="meijina">{{item.price}}</div>
                    <div class="sim_senda" @click="hour_play(item)">{{$t('new_test5.Continue')}}</div>
                </div>
            </div>
          </div>
        </div>



        <div class="dian mgb"></div>
      </div>
    </div>
  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
          loading:false,
          height:100,
          children_list:[],
          getCreatPlanList:[],
          package_list:[],
          n:0,
          us_info:[],

          yicang:false,
				plan_info:false,
				good_info:false,
				plandata:[],
				gooddata:[],
				time:{
					value1:'',
					value2:'',
					value3:'',
					value4:'',
					value5:'',
					value6:'',
				},

      }
    },
    created () {
      var us_info = getStore(keys.userProfile);
      let height = document.body.offsetHeight-80;
      this.height = height;
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.us_info = getStore(keys.userProfile);
      this.get_children();
      this.recharge_package();

      

    },
    methods: {
      /**
       * 选中效果
       */
      index_clind:function(index,item){
        this.n = index
        this.Get_package_list(item.kids);
      },
      /**
       * 获取孩子列表
       */
      get_children(){
        let _this = this;
        this.$http.get('/api/getKidsTypeList').then((res) => {
          _this.Get_package_list(res.data.data[0].kids);
          if(res.data.code == 200){
            this.children_list = res.data.data
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 获取课时充值套餐
       */
      recharge_package(){
        this.$http.get('/api/getCreatPlanList?user_sn='+getStore(keys.userProfile).user_sn).then((res) => {
          // console.log('获取课时充值套餐',res)
          if(res.data.code == 200){
            this.getCreatPlanList = res.data.data
            
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 获取套餐列表
       */
      Get_package_list(kids_id){
        this.loading = true;
        let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
        this.$http.get('/api/getPlanList?kids='+kids_id+'&user_sn='+getStore(keys.userProfile).user_sn).then((res) => {
          if(res.data.code == 200){
            this.package_list = res.data.data
            this.loading = false
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 判断是否是会员并且跳转确认支付方法
       */
      local_play(e){
        let _this = this;
        var us_info = getStore(keys.userProfile);
        this.$http.post('/api/buyMember', {
          plan_id:e.id
        }).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.Order_information,res.data.data)
            _this.$router.push({ path:'/home/children/CompletePayment'});
          } else {
            _this.$message({
              message: res.data.msg,
              type: 'warning'
            })  
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })

        /**
         * 更换套餐页面：暂时不需要
         */
        // this.$router.push({ path:'/home/children/CompletePayment' , query:{ plan_id:e.id }});
      },
      /**
       * 充值课时方法
       */
      hour_play(item){
        let _this = this;
        var us_info = getStore(keys.userProfile);
        this.$http.post('/api/buyCredit', {
          good_id:item.id
        }).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.Order_information,res.data.data)
            _this.$router.push({ path:'/home/children/CompletePayment'});
          } else {
            _this.$message({
              message: res.data.msg,
              type: 'warning'
            })  
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      }

      
    },
    mounted () {
      var that=this
      this.$http.get('/api/getHidePlanList').then((res) => {
         if (res.data.code == 200) {
           let HidePlanList=res.data.data;
           if(HidePlanList.is_show){
						this.yicang=true;
            var plan=HidePlanList.plan_info
						var good=HidePlanList.good_info
						if(plan!=''){
							this.plan_info=true
							this.plandata=HidePlanList.plan_info
							
						}
						if(good!=''){
							this.good_info=true
							this.gooddata=HidePlanList.good_info
						}
						this.daojishi=HidePlanList.seconds_left
						var mount= setInterval(function timestampToTime(){
							
							if(that.daojishi==0){
								that.yicang = false;
								clearInterval(mount)
							}
							else{
								var h = parseInt(that.daojishi/ 60 / 60  , 10);
								
								if( h < 10){
									that.time.value1='0'
									that.time.value2= h.toString()
								}
								else{
									that.time.value1=h.toString().slice(0, 1)
									that.time.value2= h.toString().slice(1, 2)

								}
								var m = parseInt(that.daojishi/ 60 % 60, 10);//计算剩余的分钟
								if( m < 10){
									that.time.value3='0'
									that.time.value4= m.toString()
								} 
								else{
									that.time.value3=m.toString().slice(0, 1)
									that.time.value4= m.toString().slice(1, 2)
								}
							
								 var s = parseInt(that.daojishi % 60, 10);//计算剩余的秒数 
								if(s < 10){
									that.time.value5='0'
									that.time.value6= s.toString()
								}
								else{
									that.time.value5=s.toString().slice(0, 1)
									that.time.value6=s.toString().slice(1, 2)
								}
								that.daojishi=that.daojishi-1
								
							}

						}	, 1000)

					 }
         }
        
      });
    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>




.el-main{
  overflow: inherit;
}
.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    text-align: center;

}
.Set_meal_content{
    width: 317px;
    height: 614px;
    left: 388px;
    top: 258px;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;
    border-radius: 16.6583px;
}
.imtxt{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    // line-height: 33px;
    /* identical to box height, or 118% */
    text-align: center;
    color: #4B69FE;
    margin-top: 41px;
}
.kunmder{
    width: 90px;
    height: 27px;
    border: 1px solid #000000;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 27px;
    /* identical to box height, or 107% */
    text-align: center;
    color: #000000;
    margin: 0px auto 0 auto;
}
.wenzis{
    height: 21px;
    font-family: Poppins;
    font-style: italic;
    font-weight: 500;
    font-size: 16px;
    // line-height: 24px;
    margin-top:10px;
    /* identical to box height, or 150% */
    text-align: center;
    color: #8E8E8E;
}
.ikk_jiage{
    // width: 149px;
    // height: 35px;
    border:0px solid red;
    margin-top: 15px;
}
.num{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 39px;
    // line-height: 35px;
    /* identical to box height, or 89% */
    text-align: center;
    color: #000000;
    display: block;
}
.immmqqq{
    font-family: 'Sofia Pro-Regular';
    font-style: normal;
    font-weight: 100;
    font-size: 15px;
    // line-height: 35px;
    /* identical to box height, or 89% */
    text-align: center;
    color: #000000;
}
.miaoshu{
    font-family: Poppins;
    font-style: italic;
    font-weight: normal;
    font-size: 10px;
    line-height: 10px;
    text-align: center;
    color: #000000;
    margin-top:11px;
}
.botton_content{
    width: 262px;
    flex:1;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom:40px;
    margin-top:57px;
    margin: 40px auto 57px auto;
    padding-top: 26px;
}
.sihh_list{
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 29px;
    color: #000000;
    margin-bottom:8px;
}
.sin_imm{
    margin-left: 16px;
}
.send{
    cursor: pointer;
    width: 250px;
    height: 46px;
    left: 422px;
    top: 796px;
    background: #4B69FE;
    border-radius: 26.6464px;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 46px;
    /* identical to box height, or 100% */
    text-align: center;
    color: #FFFFFF;
    margin: 0 auto 30px auto;

}
.select_ry{
    width:500px;
    // height: 10px;
    border:0px solid red;
    margin: 38px auto 52px auto;

    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 18px;
    /* identical to box height, or 97% */
    text-align: center;
    color: #000000;
}
.sz{
    width: 64px;
    height: 35px;
    left: 955px;
    top: 179px;
    border: 1px solid #F1F1F1;
    box-sizing: border-box;
    border-radius: 22.75px;
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 35px;
    /* identical to box height, or 92% */
    // text-align: right;
    color: #ABABAB;
    display: inline-block;
    margin-right: 9px;
    cursor: pointer;
}
.mhn{
    margin-bottom:30px;
    margin-top:30px;
}
.bomnera{
    border:none !important;
    background:#ffffff !important;
}
.tossu{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    color: #4B69FE;
    margin-top: 30px;
}
.xiamm{
    text-align: center;
    font-size: 16px;
    margin-top:10px;
    height: 21px;
}
.meijina{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 27px;
    line-height: 35px;
    /* identical to box height, or 128% */
    text-align: center;
    color: #000000;
    text-align: center;
    margin-top:24px;
}
.sim_senda{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 40px;
    /* identical to box height, or 100% */
    text-align: center;
    color: #4B69FE;
    width: 150px;
    height: 40px;
    border: 1.33232px solid #4B69FE;
    box-sizing: border-box;
    border-radius: 30px;
    margin: 7px auto 30px auto;
    cursor: pointer;
}

  /deep/ .el-row {
    margin:0;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-col {
      border-radius: 4px;
      padding:0;
      margin-right:5px;
      &:last-child{
        margin-right:0;
      }
    }
  }
  .bg-purple-dark {
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;
    border-radius: 16.6583px;
  }
  .bg-purple {
    // background: #d3dce6;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;
    border-radius: 16.6583px;
    
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    margin-bottom:9px;
  }
  .hrp{
    height:100%;
    display: flex;
    flex-direction: column;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .checked{
    color:#ffffff !important;
    background: #4B69FE;
  }
.base_content{
  width: fit-content;
  padding: 0 10px;
  height: 29px;
  background: #2EC37A;
  border-radius: 19.9848px;
  margin: -12px auto 0 auto;
  text-align: center;
  line-height: 29px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0.03em;
  // text-transform: uppercase;
  color: #FFFFFF;
}
.m_tin{
  margin: 43px auto 0 auto;
  height: 27px;
}
.sin{
  height: 29px;
  margin-top: -12px;
}
.flex-wrap{
  display: flex;
  flex-wrap: wrap;
    justify-content: space-evenly;
}
.flex-wrap-start{
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  max-width: 1026px;
  margin: 0 auto;
}
.wrap-div{
  width:400px;
  margin-right:10px;
  &:nth-child(2n){
    margin:0;
  }
}
.top_month-div{
  width: 322px;
  margin-right:20px;
  margin-bottom:20px;
  &:last-child{
    margin-right:0;
  }
}
.flex-center{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 875px;
  margin: 0 auto;
}
.daojishi{
			width: 100%;
			margin-bottom: 60px;
		}
		.headerone{
			// position: absolute;
			width: 547px;
			height: 116px;
			margin: 0px auto;
			font-weight: 600;
			font-size: 43px;
			line-height: 58px;
			text-align: center;
			color: #F3A735;
			span{
				display: block;
			}
		}
		.headtwo{
			flex-wrap:wrap;
			display: flex;
			margin:60px auto ;
			width: 600px;

			span{
				text-align: center;
				width: 120px;
				height: 79px;
				font-weight: 500;
				font-size: 24px;
				line-height: 79px;
				color: rgba(11, 29, 51, 0.6);
				
			}
			.headtwo-time{
				width: 360px;
				
				display: flex;
        margin-left: 120px;
				span{
					width: 10px;
					height: 79px;
					margin: 0px 20px;
					color: #000000;
					text-align: center;
					font-size: 34px;
					line-height: 79px;
					font-weight: 600;
				}
				.timeclass{
					width: 42px;
					height: 79px;
					margin: 0 1.5px;
					background: #000000;
					border-radius: 4px;
					color: #FFFFFF;
					font-family: 'Digital Numbers';
					font-style: normal;
					font-weight: 400;
					font-size: 34px;
					line-height: 79px;
					text-align: center;
					padding: 0 ;
				}
			}	
			.headtwo-timetext{

				margin: 12px auto;
				width: 100%;
				padding: 0px 120px;
				span{
          display:inline-block;
					color: #000000;
					font-weight: 400;
					font-size: 14px;
					line-height: 16px;
					text-align: center;
					text-transform: uppercase;
					width: 80px;
					
				}
				.one{
					 margin-right: 25px;
				}
				.two{
					margin-right: 15px;
				}
				
				
			}
		}
	
		.headthree{
			width: 353px;
			height: 470px;
			background: #FFFFFF;
			box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.15);
			border-radius: 16.66px;
			margin: 10px auto;
			.headthree-img{
				position: relative;
				.imgone{
					position: absolute;
					top: 36px;
					left: 76px;
					z-index: 999;
				}
				.imgtwo{
					position: absolute;
					top:60px;
					left: 110px;
				}
				span{
					position: absolute;
					top:65px;
					left: 158px;
					font-family: 'Sofia Pro';
					font-style: normal;
					font-weight: 700;
					font-size: 16px;
					line-height: 34px;
					text-align: center;
					color: #FFFFFF;
				}
			}
			.headthree-taocan{
				position: relative;
				.base_sin{
					position: absolute;
					width: 128px;
           height: 29px;
					background: #2EC37A;
           border-radius: 19.9848px;
					font-weight: 700;
					font-size: 13px;
					line-height: 29px;
					text-transform: uppercase;
					color: #FFFFFF;
					left: 110px;
					// top: -15px;
					text-align: center;
					
				}
				.spanone{
					position: absolute;
					width:300px;
					left:22px;
					// height: 33px;
					top: 164px;
					font-family: 'Poppins';
					font-style: normal;
					font-weight: 400;
					font-size: 24px;
					line-height: 33px;
					text-align: center;
					color: #000000;
				}
				.spantwo{
					position: absolute;
					width: 249px;
					height: 22px;
					left: 52px;
					top: 207px;
					font-family: 'Poppins';
					font-style: italic;
					font-weight: 500;
					font-size: 15px;
					line-height: 22px;
					text-align: center;
					color: #8E8E8E;
					
				}
				.spantwo-div{
					margin-top: 30px;
					position: absolute;	
					top: 215px;
					left: 130px;
					span{
						
						text-align: center;
						margin: 0px auto;
					}
					.spantwo-span{
						width: 80px;
					}

				}
				.spanthree{
					position: absolute;
					width: 300px;
					left: 22px;
					top: 299px;
					font-weight: 400;
					font-size: 13px;
					color: #FF0000;
					text-align: center;
					span{
						font-weight: 600;
						font-size: 44px;
						line-height: 35px;
						text-align: center;
						
						
					}
					
				}
				.spanfour{
					position: absolute;
					
					left: 147px;
					top: 357px;
					font-style: italic;
					font-weight: 400;
					font-size: 10px;
					line-height: 10px;
					text-align: center;
					color: #000000;
				}
			}
			.p-1{
		margin-top: 51px;
		height: 27px;
		text-align: center;
		font-size: 15px;
		span{
			font-weight: 700;
            font-size: 15px;
            line-height: 16px;
		   text-align: center;
		   height: 16px;
		}
	}
		}
		.buttoninit{
			position: absolute;
			top: 390px;
			left: 45px;
			width: 262px;
			height: 46px;
			background: #FF0B0B;
			border-radius: 26.6464px;
			font-weight: 600;
			font-size: 16px;
			line-height: 16px;
			text-align: center;
			color: #FFFFFF;
			animation: pulse 1s infinite;
		}
		@keyframes pulse{
			0% {
				-webkit-transform: scaleX(1);
				transform: scaleX(1);
			}
			50% {
				-webkit-transform: scale3d(1.05,1.05,1.05);
				transform: scale3d(1.05,1.05,1.05);
			}
			100% {
				-webkit-transform: scaleX(1);
				transform: scaleX(1);
			}
		}
		@-webkit-keyframes pulse /* Safari and Chrome */{
			0% {
				-webkit-transform: scaleX(1);
				transform: scaleX(1);
			}
			50% {
				-webkit-transform: scale3d(1.05,1.05,1.05);
				transform: scale3d(1.05,1.05,1.05);
			}
			100% {
				-webkit-transform: scaleX(1);
				transform: scaleX(1);
			}
		}

</style>



// WEBPACK FOOTER //
// src/components/children/PurchaseLessonPlan.vue